module.exports = __webpack_public_path__ + "img/ipad@2x.635985ba.png";